import React from 'react';
import { ChevronRight } from 'lucide-react';
import DotsMenu from './DotsMenu';
import Checkbox from './Checkbox';
import { getPriorityColor } from './utils';

const TaskItem = ({
  item,
  type,
  isSelected,
  onClick,
  onToggleCompletion,
  draggedItem,
  handleDragStart,
  handleDragOver,
  handleDrop,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  deleteItem,
  setPriority,
  goalId,
  stepId,
  taskId,
  editingItemId,
  setEditingItemId,
  editingText,
  setEditingText,
  updateItemTitle,
  childCount
}) => {
  return (
    <div
      className={`border-b p-2 flex items-center cursor-pointer 
        ${getPriorityColor(item.priority, isSelected)}
        ${draggedItem?.id === item.id ? 'opacity-100' : ''}`}
      onClick={onClick}
      draggable
      onDragStart={() => handleDragStart(item, type)}
      onDragOver={handleDragOver}
      onDrop={() => handleDrop(item, type)}
    >
      <Checkbox
        checked={item.completed}
        onChange={() => onToggleCompletion(item.id)}
      />
      <div 
        className={`flex-1 ${item.completed ? 'line-through text-gray-400' : ''}`}
        onDoubleClick={() => {
          setEditingItemId(`${type}-${item.id}`);
          setEditingText(item.title);
        }}
      >
        {editingItemId === `${type}-${item.id}` ? (
          <input
            className="w-full p-1 border rounded"
            value={editingText}
            onChange={(e) => setEditingText(e.target.value)}
            onBlur={() => updateItemTitle(item.id, editingText)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                updateItemTitle(item.id, editingText);
              }
            }}
            autoFocus
          />
        ) : (
          item.title
        )}
      </div>
      <div className="flex items-center">
        <DotsMenu
          id={item.id}
          type={type}
          goalId={goalId}
          stepId={stepId}
          taskId={taskId}
          openMenuId={openMenuId}
          setOpenMenuId={setOpenMenuId}
          openSubmenuId={openSubmenuId}
          setOpenSubmenuId={setOpenSubmenuId}
          deleteGoal={type === 'goal' ? deleteItem : undefined}
          deleteStep={type === 'step' ? deleteItem : undefined}
          deleteTask={type === 'task' ? deleteItem : undefined}
          deleteInitiative={type === 'initiative' ? deleteItem : undefined}
          setGoalPriority={type === 'goal' ? setPriority : undefined}
          setStepPriority={type === 'step' ? setPriority : undefined}
          setTaskPriority={type === 'task' ? setPriority : undefined}
          setInitiativePriority={type === 'initiative' ? setPriority : undefined}
        />
        {type !== 'initiative' && (
          <>
            <span className="text-gray-400 ml-1 mr-1">{childCount}</span>
            <ChevronRight size={16} />
          </>
        )}
      </div>
    </div>
  );
};

export default TaskItem; 